<template>
  <div class="margin-t10">
    <van-button round block type="info" native-type="submit" @click="confirm">确定</van-button>
  </div>
</template>
<script>
import { AddPointApplyInfo } from '@/api/EducationalPoints'
import { Notify } from 'vant'
import { Dialog } from 'vant'
const moment = require('moment')
export default {
  name: 'ApplyButton',
  components: {
    [Notify.Component.name]: Notify.Component,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
    }
  },
  created: function() {
  },
  mounted() {
  },
  methods: {
    confirm() {
      const check = this.Required()
      if (check === true) {
        Dialog.confirm({
          title: '提示',
          message: '是否确认申请?'
        })
          .then(() => {
            this.determine()
          })
          .catch(() => {
          })
      }
    },
    determine() {
      const that = this
      // 控件check
      var formDataFile = new FormData()
      // 用户id
      formDataFile.append('user_id', that.$store.getters.usercode)
      // 用户名称
      formDataFile.append('user_name', that.$store.getters.username)
      // 申请者id
      formDataFile.append('applicant_id', that.$store.getters.usercode)
      // 申请者名称
      formDataFile.append('applicant_name', that.$store.getters.username)
      // 申请日期
      formDataFile.append('apply_date', moment().format('YYYY-MM-DD'))
      // 申请金额
      formDataFile.append('money', that.$parent.reimbursementamount)
      // 申请积分数
      formDataFile.append('score', that.$parent.applypoints)
      // 申请说明
      formDataFile.append('content', that.$parent.applicationdescription)
      // 申请类型
      formDataFile.append('apply_type', that.$parent.aplicationtypeid)
      // 批准状态
      formDataFile.append('approval_status', '0')
      // 批准者id
      formDataFile.append('approval_user_id', that.$parent.reviewerid)
      // 批准者名称
      formDataFile.append('approval_user_name', that.$parent.reviewername)
      // 拒绝理由
      formDataFile.append('refuse_reason', '')
      // 上传文件信息不为空
      if (that.$parent.uploader.length !== 0) {
        that.$parent.uploader.forEach(item => {
          formDataFile.append('fileUpload', item.file)
        })
      // 上传文件信息为空
      } else {
        formDataFile.append('fileUpload', '')
      }
      AddPointApplyInfo(formDataFile, function(res) {
        if (res.code === 0) {
          that.toEducationalPoints()
          Notify({ type: 'success', message: '申请成功', duration: 1000 })
        } else {
          Notify({ type: 'danger', message: '申请失败', duration: 1000 })
        }
      })
    },
    toEducationalPoints() {
      this.$router.push(
        { path: '/index/EducationalPoints' }
      )
    },
    Required() {
      // 申请对象
      if (this.$parent.aplicationobject === '') { Notify({ type: 'warning', message: '请填写申请对象!', duration: 1000 }); return false }
      // 小数点不能超过两位
      const r = /^(([1-9][0-9]*)|((d{1,4}\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
      if (!r.test(this.$parent.reimbursementamount)) { Notify({ type: 'warning', message: '报销金额请输入正数并且小数位不能超过两位!', duration: 1500 }); return false }
      // 报销金额不能大于可用积分数
      if (parseInt(this.$parent.reimbursementamount) > parseInt(this.$parent.pointSum)) { Notify({ type: 'warning', message: '可用积分不足!', duration: 1500 }); return false }
      // 报销金额不能为0
      if (parseInt(this.$parent.reimbursementamount) === 0) { Notify({ type: 'warning', message: '报销金额请输入正数并且小数位不能超过两位!', duration: 1500 }); return false }
      // 报销金额不能小于0
      if (this.$parent.reimbursementamount < 0) { Notify({ type: 'warning', message: '报销金额请输入正数并且小数位不能超过两位!', duration: 1500 }); return false }
      // 报销金额不能为空
      if (this.$parent.reimbursementamount === '') { Notify({ type: 'warning', message: '请填写报销金额!', duration: 1500 }); return false }
      // 申请类型
      if (this.$parent.aplicationtypename === '') { Notify({ type: 'warning', message: '请填写申请类型!', duration: 1500 }); return false }
      // 申请说明
      if (this.$parent.applicationdescription === '') { Notify({ type: 'warning', message: '请填写申请说明!', duration: 1500 }); return false }
      // 审核人
      if (this.$parent.reviewertext === '') { Notify({ type: 'warning', message: '请填写审批人名!', duration: 1500 }); return false }
      return true
    }
  }
}
</script>
<style scoped>
  .margin-t10{
    padding: 15px 8px 0px 8px;
  }
</style>
